<div class="spinner">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando</p>
  </div>
</div>

<div class="bg" [style.backgroundColor]="bgColor"></div>